import { render } from "./LanguageIcon.vue?vue&type=template&id=672e72a6"
import script from "./LanguageIcon.vue?vue&type=script&lang=js"
export * from "./LanguageIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__